<template>
  <el-dialog :visible.sync="visible"
             :title="!dataForm.id ? $t('user.transfer') : $t('user.transfer')"
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             width="1000px">
    <el-form :model="modifyForm"
             :rules="dataRule"
             ref="modifyForm"
             style="margin-top:10px;padding-bottom:50px"
             label-position="top">
      <el-row>
        <el-col :span="5">
          <el-form-item label=""></el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="">
            <span style="font-size:16px;font-weight:bold">转岗前</span>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label=""></el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="">
            <span style="font-size:16px;font-weight:bold">转岗后</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row style="margin-top:20px">
        <!-- 转岗前所属经销商网点 -->
        <el-col :span="6">
          <el-form-item label="所属经销商网点"
                        prop="">
            <el-select v-model="dataForm.orgId"
                       filterable
                       placeholder=""
                       :disabled="true">
              <el-option v-for="(item) in beforOrglist"
                         :key="item.orgId"
                         :label="item.name"
                         :value="item.orgId">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 转岗前主要职位 -->
        <el-col :span="6">
          <el-form-item label="主要职位"
                        prop="">
            <el-tooltip class="item"
                        effect="dark"
                        placement="top">
              <div slot="content"
                   v-html="beforJobCodeContent"></div>
              <el-select v-model="dataForm.jobCode"
                         filterable
                         placeholder=""
                         clearable
                         :disabled="true">
                <el-option v-for="(item) in positionlist"
                           :key="item.positionCode"
                           :label="item.positionName"
                           :value="item.positionCode">
                </el-option>
              </el-select>
            </el-tooltip>
          </el-form-item>
        </el-col>
        <!-- 转岗后所属经销商网点 -->
        <el-col :span="6">
          <el-form-item label="所属经销商网点"
                        prop="agreePolicy">
            <el-select v-model="modifyForm.orgId"
                       filterable
                       clearable
                       remote
                       placeholder=""
                       :remote-method="mainOutletOnequerySearch"
                       @change="orgIdChange">
              <el-option v-for="(item) in orglist"
                         :key="item.orgId"
                         :label="item.name"
                         :value="item.orgId">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 转岗后主要职位 -->
        <el-col :span="6">
          <el-form-item label="主要职位"
                        prop="jobCode">
            <el-tooltip class="item"
                        effect="dark"
                        placement="right">
              <div slot="content"
                   v-html="jobCodeContent"></div>
              <el-select v-model="modifyForm.jobCode"
                         filterable
                         remote
                         placeholder="请输入"
                         :remote-method="jobCodequerySearch"
                         @change="jobLimit(modifyForm.jobCode)"
                         clearable
                         :disabled="jobCodeabled">
                <el-option v-for="(item) in mainPositionList"
                           :key="item.positionCode"
                           :label="item.positionName"
                           :value="item.positionCode">
                </el-option>
              </el-select>
            </el-tooltip>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <!-- 转岗前兼职网点1 -->
        <el-col :span="6">
          <el-form-item label="兼职1所属网点"
                        prop="">
            <el-select v-model="dataForm.partTimeOutletOne"
                       filterable
                       placeholder=""
                       clearable
                       :disabled="true">
              <el-option v-for="(item) in orglistOne"
                         :key="item.orgId"
                         :label="item.name"
                         :value="item.orgId">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 转岗前兼职1 -->
        <el-col :span="6">
          <el-form-item label="兼职职位1"
                        prop="">
            <el-tooltip class="item"
                        effect="dark"
                        placement="top">
              <div slot="content"
                   v-html="beforJobCodeContentOne"></div>
              <el-select v-model="dataForm.partTimeJobcodeOne"
                         filterable
                         placeholder=""
                         :disabled="true">
                <el-option v-for="(item) in positionlistOne"
                           :key="item.positionCode"
                           :label="item.positionName"
                           :value="item.positionCode">
                </el-option>
              </el-select>
            </el-tooltip>
          </el-form-item>
        </el-col>
        <!-- 转岗后兼职网点1 -->
        <el-col :span="6">
          <el-form-item label="兼职1所属网点"
                        prop="partTimeOutletOne">
            <el-select v-model="modifyForm.partTimeOutletOne"
                       filterable
                       remote
                       placeholder="请输入"
                       :disabled="OutletOneabled"
                       :remote-method="outletOnequerySearch"
                       @change="changeOutletOne"
                       clearable>
              <el-option v-for="item in outletOneOrglist"
                         :key="item.orgId"
                         :label="item.name"
                         :value="item.orgId">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 转岗后兼职1 -->
        <el-col :span="6">
          <el-form-item label="兼职职位1"
                        prop="partTimeJobcodeOne">
            <el-tooltip class="item"
                        effect="dark"
                        placement="right">
              <div slot="content"
                   v-html="jobCodeContentOne"></div>
              <el-select v-model="modifyForm.partTimeJobcodeOne"
                         filterable
                         remote
                         :disabled="partTimeJobcodeOneabled"
                         placeholder="请输入"
                         :remote-method="partTimeJobcodeOnequerySearch"
                         @change="parttimejobRepeatOne(modifyForm.partTimeJobcodeOne)"
                         clearable>
                <el-option v-for="(item) in newParttimePositionListOne"
                           :key="item.positionCode"
                           :label="item.positionName"
                           :value="item.positionCode">
                </el-option>
              </el-select>
            </el-tooltip>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <!-- 转岗前兼职网点2 -->
        <el-col :span="6">
          <el-form-item label="兼职2所属网点"
                        prop="">
            <el-select v-model="dataForm.partTimeOutletTwo"
                       filterable
                       placeholder=""
                       clearable
                       :disabled="true">
              <el-option v-for="(item) in orglistTwo"
                         :key="item.orgId"
                         :label="item.name"
                         :value="item.orgId">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 转岗前兼职2 -->
        <el-col :span="6">
          <el-form-item label="兼职职位2"
                        prop="">
            <el-tooltip class="item"
                        effect="dark"
                        placement="top">
              <div slot="content"
                   v-html="beforJobCodeContentTwo"></div>
              <el-select v-model="dataForm.partTimeJobcodeTwo"
                         filterable
                         placeholder=""
                         clearable
                         :disabled="true">
                <el-option v-for="(item) in positionlistTwo"
                           :key="item.positionCode"
                           :label="item.positionName"
                           :value="item.positionCode">
                </el-option>
              </el-select>
            </el-tooltip>
          </el-form-item>
        </el-col>
        <!-- 转岗后兼职网点2 -->
        <el-col :span="6">
          <el-form-item label="兼职2所属网点"
                        prop="partTimeOutletTwo">
            <el-select v-model="modifyForm.partTimeOutletTwo"
                       filterable
                       remote
                       :disabled="OutletTwoabled"
                       placeholder="请输入"
                       @change="changeOutletTwo"
                       :remote-method="outletTwoquerySearch"
                       clearable>
              <el-option v-for="(item) in outletTwoOrglist"
                         :key="item.orgId"
                         :label="item.name"
                         :value="item.orgId">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 转岗后兼职2 -->
        <el-col :span="6">
          <el-form-item label="兼职职位2"
                        prop="partTimeJobcodeTwo">
            <el-tooltip class="item"
                        effect="dark"
                        placement="right">
              <div slot="content"
                   v-html="jobCodeContentTwo"></div>
              <el-select v-model="modifyForm.partTimeJobcodeTwo"
                         filterable
                         remote
                         :disabled="partTimeJobcodeTwoabled"
                         placeholder="请输入"
                         :remote-method="partTimeJobcodeTwoquerySearch"
                         @change="parttimejobRepeatTwo(modifyForm.partTimeJobcodeTwo)"
                         clearable>
                <el-option v-for="(item) in newParttimePositionListTwo"
                           :key="item.positionCode"
                           :label="item.positionName"
                           :value="item.positionCode">
                </el-option>
              </el-select>
            </el-tooltip>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <!-- 转岗前兼职网点3 -->
        <el-col :span="6">
          <el-form-item label="兼职3所属网点"
                        prop="">
            <el-select v-model="dataForm.partTimeOutletThree"
                       filterable
                       placeholder=""
                       clearable
                       :disabled="true">
              <el-option v-for="(item) in orglistThree"
                         :key="item.orgId"
                         :label="item.name"
                         :value="item.orgId">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 转岗前兼职3 -->
        <el-col :span="6">
          <el-form-item label="兼职职位3"
                        prop="">
            <el-tooltip class="item"
                        effect="dark"
                        placement="top">
              <div slot="content"
                   v-html="beforJobCodeContentThree"></div>
              <el-select v-model="dataForm.partTimeJobcodeThree"
                         filterable
                         placeholder=""
                         clearable
                         :disabled="true">
                <el-option v-for="(item) in positionlistThree"
                           :key="item.positionCode"
                           :label="item.positionName"
                           :value="item.positionCode">
                </el-option>
              </el-select>
            </el-tooltip>
          </el-form-item>
        </el-col>
        <!-- 转岗后兼职网点3 -->
        <el-col :span="6">
          <el-form-item label="兼职3所属网点"
                        prop="partTimeOutletThree">
            <el-select v-model="modifyForm.partTimeOutletThree"
                       filterable
                       remote
                       :disabled="OutletThreeabled"
                       placeholder="请输入"
                       @change="changeOutletThree"
                       :remote-method="outletThreequerySearch"
                       clearable>
              <el-option v-for="(item) in outletThreeOrglist"
                         :key="item.orgId"
                         :label="item.name"
                         :value="item.orgId">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 转岗后兼职3 -->
        <el-col :span="6">
          <el-form-item label="兼职职位3"
                        prop="partTimeJobcodeThree">
            <el-tooltip class="item"
                        effect="dark"
                        placement="right">
              <div slot="content"
                   v-html="jobCodeContentThree"></div>
              <el-select v-model="modifyForm.partTimeJobcodeThree"
                         filterable
                         remote
                         :disabled="partTimeJobcodeThreeabled"
                         placeholder="请输入"
                         :remote-method="partTimeJobcodeThreequerySearch"
                         @change="parttimejobRepeatThree(modifyForm.partTimeJobcodeThree)"
                         clearable>
                <el-option v-for="(item) in newParttimePositionListThree"
                           :key="item.positionCode"
                           :label="item.positionName"
                           :value="item.positionCode">
                </el-option>
              </el-select>
            </el-tooltip>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <!-- 转岗前兼职网点4 -->
        <el-col :span="6">
          <el-form-item label="兼职4所属网点"
                        prop="">
            <el-select v-model="dataForm.partTimeOutletFour"
                       filterable
                       placeholder=""
                       clearable
                       :disabled="true">
              <el-option v-for="(item) in orglistFour"
                         :key="item.orgId"
                         :label="item.name"
                         :value="item.orgId">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 转岗前兼职4 -->
        <el-col :span="6">
          <el-form-item label="兼职职位4"
                        prop="">
            <el-tooltip class="item"
                        effect="dark"
                        placement="top">
              <div slot="content"
                   v-html="beforJobCodeContentFour"></div>
              <el-select v-model="dataForm.partTimeJobcodeFour"
                         filterable
                         placeholder=""
                         clearable
                         :disabled="true">
                <el-option v-for="(item) in positionlistFour"
                           :key="item.positionCode"
                           :label="item.positionName"
                           :value="item.positionCode">
                </el-option>
              </el-select>
            </el-tooltip>
          </el-form-item>
        </el-col>
        <!-- 转岗后兼职网点4 -->
        <el-col :span="6">
          <el-form-item label="兼职4所属网点"
                        prop="partTimeOutletFour">
            <el-select v-model="modifyForm.partTimeOutletFour"
                       filterable
                       remote
                       :disabled="OutletFourabled"
                       placeholder="请输入"
                       @change="changeOutletFour"
                       :remote-method="outletFourquerySearch"
                       clearable>
              <el-option v-for="(item) in outletFourOrglist"
                         :key="item.orgId"
                         :label="item.name"
                         :value="item.orgId">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 转岗后兼职4 -->
        <el-col :span="6">
          <el-form-item label="兼职职位4"
                        prop="partTimeJobcodeFour">
            <el-tooltip class="item"
                        effect="dark"
                        placement="right">
              <div slot="content"
                   v-html="jobCodeContentFour"></div>
              <el-select v-model="modifyForm.partTimeJobcodeFour"
                         filterable
                         remote
                         :disabled="partTimeJobcodeFourabled"
                         placeholder="请输入"
                         :remote-method="partTimeJobcodeFourquerySearch"
                         @change="parttimejobRepeatFour(modifyForm.partTimeJobcodeFour)"
                         clearable>
                <el-option v-for="(item) in newParttimePositionListFour"
                           :key="item.positionCode"
                           :label="item.positionName"
                           :value="item.positionCode">
                </el-option>
              </el-select>
            </el-tooltip>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <!-- 转岗前兼职网点5 -->
        <el-col :span="6">
          <el-form-item label="兼职5所属网点"
                        prop="">
            <el-select v-model="dataForm.partTimeOutletFive"
                       filterable
                       placeholder=""
                       clearable
                       :disabled="true">
              <el-option v-for="(item) in orglistFive"
                         :key="item.orgId"
                         :label="item.name"
                         :value="item.orgId">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 转岗前兼职5 -->
        <el-col :span="6">
          <el-form-item label="兼职职位5"
                        prop="">
            <el-tooltip class="item"
                        effect="dark"
                        placement="top">
              <div slot="content"
                   v-html="beforJobCodeContentFive"></div>
              <el-select v-model="dataForm.partTimeJobcodeFive"
                         filterable
                         placeholder=""
                         clearable
                         :disabled="true">
                <el-option v-for="(item) in positionlistFive"
                           :key="item.positionCode"
                           :label="item.positionName"
                           :value="item.positionCode">
                </el-option>
              </el-select>
            </el-tooltip>
          </el-form-item>
        </el-col>
        <!-- 转岗后兼职网点5 -->
        <el-col :span="6">
          <el-form-item label="兼职5所属网点"
                        prop="partTimeOutletFive">
            <el-select v-model="modifyForm.partTimeOutletFive"
                       filterable
                       remote
                       :disabled="OutletFiveabled"
                       placeholder="请输入"
                       @change="changeOutletFive"
                       :remote-method="outletFivequerySearch"
                       clearable>
              <el-option v-for="(item) in outletFiveOrglist"
                         :key="item.orgId"
                         :label="item.name"
                         :value="item.orgId">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 转岗后兼职5 -->
        <el-col :span="6">
          <el-form-item label="兼职职位5"
                        prop="partTimeJobcodeFive">
            <el-tooltip class="item"
                        effect="dark"
                        placement="right">
              <div slot="content"
                   v-html="jobCodeContentFive"></div>
              <el-select v-model="modifyForm.partTimeJobcodeFive"
                         filterable
                         remote
                         :disabled="partTimeJobcodeFiveabled"
                         placeholder="请输入"
                         :remote-method="partTimeJobcodeFivequerySearch"
                         @change="parttimejobRepeatFive(modifyForm.partTimeJobcodeFive)"
                         clearable>
                <el-option v-for="(item) in newParttimePositionListFive"
                           :key="item.positionCode"
                           :label="item.positionName"
                           :value="item.positionCode">
                </el-option>
              </el-select>
            </el-tooltip>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div style="width:100%;text-align:center">
      <el-button type="primary"
                 style="width:90px;height:36px"
                 @click="dataFormSubmitHandle()"
                 :disabled="isDisable">{{$t('confirm')}}</el-button>
      <el-button style="width:90px;height:36px;margin-left:20px"
                 @click="visible = false">{{$t('cancel')}}</el-button>
    </div>
    <div class="box">
      <div class="line"></div>
    </div>
    <!-- 限制弹框 -->
    <el-dialog
      :title="$t('prompt.title')"
      :append-to-body="true"
      :modal-append-to-body="false"
      custom-class="user-transfer-islimit-modal"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="limitShow"
      :before-close="closeLimitModal"
      :width="isLimit ? '760px' : '420px'">
        <LimitInfoModal v-if="limitShow" :isLimit="isLimit" :factoryDesc="factoryDesc" @closeLimitModal="closeLimitModal"></LimitInfoModal>
    </el-dialog>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import AesUtil from "@/utils/aes_utils";
import LimitInfoModal from '@/views/modules/acdc/limitAccess/limitModal';

export default {
  components: {
    LimitInfoModal
  },
  data() {
    return {
      visible: false,
      deptList: [],
      deptListVisible: false,
      // 转岗前主要职位
      positionlist: '',
      // 转岗前兼职一
      positionlistOne: '',
      // 转岗前兼职二
      positionlistTwo: '',
      // 转岗前兼职三
      positionlistThree: '',
      // 转岗前兼职四
      positionlistFour: '',
      // 转岗前兼职五
      positionlistFive: '',
      // 网点列表
      orglist: '',
      // 转岗后网点
      beforOrglist: '',
      // 转岗后兼职
      newpositionList: '',
      id: '',
      dataForm: {
        userId: ''
      },
      // 转岗后列表
      modifyForm: {
        jobCode: '',
        partTimeOutletOne: '',
        partTimeOutletTwo: '',
        partTimeOutletThree: '',
        partTimeOutletFour: '',
        partTimeOutletFive: '',
        partTimeJobcodeOne: '',
        partTimeJobcodeTwo: '',
        partTimeJobcodeThree: '',
        partTimeJobcodeFour: '',
        partTimeJobcodeFive: ''
      },
      // 提交转岗列表
      trandferForm: {},
      // 转岗后网点一list
      outletOneOrglist: [],
      // 转岗后网点二list
      outletTwoOrglist: [],
      // 转岗后网点三list
      outletThreeOrglist: [],
      // 转岗后网点四list
      outletFourOrglist: [],
      // 转岗后网点五list
      outletFiveOrglist: [],
      // 转岗前网点一list
      orglistOne: [],
      // 转岗前兼职二网点
      orglistTwo: '',
      // 转岗前兼职三网点
      orglistThree: '',
      // 转岗前兼职四网点
      orglistFour: '',
      // 转岗前兼职五网点
      orglistFive: '',
      // 转岗后主要职位list
      mainPositionList: [],
      // 转岗后兼职职位一list
      newParttimePositionListOne: [],
      // 转岗后兼职职位二list
      newParttimePositionListTwo: [],
      // 转岗后兼职职位三list
      newParttimePositionListThree: [],
      // 转岗后兼职职位四list
      newParttimePositionListFour: [],
      // 转岗后兼职职位五list
      newParttimePositionListFive: [],
      partTimeJobcodeOneabled: true,
      partTimeJobcodeTwoabled: true,
      partTimeJobcodeThreeabled: true,
      partTimeJobcodeFourabled: true,
      partTimeJobcodeFiveabled: true,
      OutletOneabled: true,
      OutletTwoabled: true,
      OutletThreeabled: true,
      OutletFourabled: true,
      OutletFiveabled: true,
      jobCodeabled: false,
      // 转岗后职位信息描述
      jobCodeContent: this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent'),
      jobCodeContentOne: this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent'),
      jobCodeContentTwo: this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent'),
      jobCodeContentThree: this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent'),
      jobCodeContentFour: this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent'),
      jobCodeContentFive: this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent'),
      // 转岗后职位代码
      jobCodeNum: this.$t('activiti.jobCodeNum'),
      jobCodeOne: this.$t('activiti.jobCodeNum'),
      jobCodeTwo: this.$t('activiti.jobCodeNum'),
      jobCodeThree: this.$t('activiti.jobCodeNum'),
      jobCodeFour: this.$t('activiti.jobCodeNum'),
      jobCodeFive: this.$t('activiti.jobCodeNum'),
      // 转岗前职位代码
      beforJobCodeNum: this.$t('activiti.jobCodeNum'),
      beforJobCodeOne: this.$t('activiti.jobCodeNum'),
      beforJobCodeTwo: this.$t('activiti.jobCodeNum'),
      beforJobCodeThree: this.$t('activiti.jobCodeNum'),
      beforJobCodeFour: this.$t('activiti.jobCodeNum'),
      beforJobCodeFive: this.$t('activiti.jobCodeNum'),
      // 转岗前职位信息描述
      beforJobCodeContent: this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent'),
      beforJobCodeContentOne: this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent'),
      beforJobCodeContentTwo: this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent'),
      beforJobCodeContentThree: this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent'),
      beforJobCodeContentFour: this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent'),
      beforJobCodeContentFive: this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent'),
      dialogshow: true,
      dialogshow1: true,
      dialogshow2: true,
      dialogshow3: true,
      dialogshow4: true,
      // 判断是否可以转岗
      trandferCode: '',
      jobCode0: '',
      jobCode1: '',
      jobCode2: '',
      jobCode3: '',
      jobCode4: '',
      jobCode5: '',
      isDisable: false,
      limitShow: false,
      isLimit: false,
      factoryDesc: ''
    }
  },
  // 校验
  computed: {
    dataRule() {
      // 转岗后兼职一
      let validatorPartTimeJobcodeOne = (rule, value, callback) => {
        if (this.modifyForm.partTimeOutletOne && this.modifyForm.partTimeOutletOne !== '') {
          if (value === '' || value === null || value === undefined) {
            callback(new Error(this.$t('user.transferAfterParttimeJob1')))
          } else {
            callback()
          }
        } else {
          callback()
        }
        callback()
      }
      // 转岗后兼职二
      let validatorPartTimeJobcodeTwo = (rule, value, callback) => {
        if (this.modifyForm.partTimeOutletTwo && this.modifyForm.partTimeOutletTwo !== '') {
          if (value === '' || value === null || value === undefined) {
            callback(new Error(this.$t('user.transferAfterParttimeJob2')))
          } else {
            callback()
          }
        } else {
          callback()
        }
        callback()
      }
      // 转岗后兼职三
      let validatorPartTimeJobcodeThree = (rule, value, callback) => {
        if (this.modifyForm.partTimeOutletThree && this.modifyForm.partTimeOutletThree !== '') {
          if (value === '' || value === null || value === undefined) {
            callback(new Error(this.$t('user.transferAfterParttimeJob3')))
          } else {
            callback()
          }
        } else {
          callback()
        }
        callback()
      }
      // 转岗后兼职四
      let validatorPartTimeJobcodeFour = (rule, value, callback) => {
        if (this.modifyForm.partTimeOutletFour && this.modifyForm.partTimeOutletFour !== '') {
          if (value === '' || value === null || value === undefined) {
            callback(new Error(this.$t('user.transferAfterParttimeJob4')))
          } else {
            callback()
          }
        } else {
          callback()
        }
        callback()
      }
      // 转岗后兼职五
      let validatorPartTimeJobcodeFive = (rule, value, callback) => {
        if (this.modifyForm.partTimeOutletFive && this.modifyForm.partTimeOutletFive !== '') {
          if (value === '' || value === null || value === undefined) {
            callback(new Error(this.$t('user.transferAfterParttimeJob5')))
          } else {
            callback()
          }
        } else {
          callback()
        }
        callback()
      }
      return {
        // 离职原因
        jobCode: [
          { required: true, message: this.$t('user.userJobCode'), trigger: 'change' }
        ],
        agreePolicy: [
          { required: true, message: this.$t('user.outletNew'), trigger: 'change' }
        ],
        // 转岗后兼职一校验
        partTimeJobcodeOne: [
          { validator: validatorPartTimeJobcodeOne, trigger: 'change' }
        ],
        // 转岗后兼职二校验
        partTimeJobcodeTwo: [
          { validator: validatorPartTimeJobcodeTwo, trigger: 'change' }
        ],
        // 转岗后兼职三校验
        partTimeJobcodeThree: [
          { validator: validatorPartTimeJobcodeThree, trigger: 'change' }
        ],
        // 转岗后兼职四校验
        partTimeJobcodeFour: [
          { validator: validatorPartTimeJobcodeFour, trigger: 'change' }
        ],
        // 转岗后兼职五校验
        partTimeJobcodeFive: [
          { validator: validatorPartTimeJobcodeFive, trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    init() {
      this.jobCode0 = ''
      this.jobCode1 = ''
      this.jobCode2 = ''
      this.jobCode3 = ''
      this.jobCode4 = ''
      this.jobCode5 = ''
      this.visible = true

      const base64url = require('base64-url')
      let aes = new AesUtil()
      let userId = base64url.encode(aes.encrypt(this.id + ''))

      this.$request.get(`/sys/commuser/infomt/${userId}`).then((res, total, code, data) => {
        this.dataForm = JSON.parse(JSON.stringify(res))
        this.modifyForm = JSON.parse(JSON.stringify(res))
        // 主要网点回显
        this.$request.get('/sys/org/selectOrgByParam',
          {
            orgId: this.dataForm.orgId,
            orgType: this.dataForm.orgType
          }
        ).then((res, total, code, data) => {
          // 经销商时需要回显品牌
          this.beforOrglist = JSON.parse(JSON.stringify(res))
          this.orglist = JSON.parse(JSON.stringify(res))
        }).catch(() => { })
        // 主要职位回显
        if (this.modifyForm.jobCode !== '' && this.modifyForm.jobCode !== null && this.modifyForm.jobCode !== undefined) {
          this.$request.get(`/sys/commuser/selectPositionByCode`,
            {
              positionCode: this.dataForm.jobCode + ''
            }).then((res, total, code, data) => {
              this.positionlist = JSON.parse(JSON.stringify(res))
              this.mainPositionList = JSON.parse(JSON.stringify(res))
              this.jobCodeNum = this.$t('activiti.jobCodeNum') + this.mainPositionList[0].positionCode
              if (this.mainPositionList[0].positionDesc) {
                this.jobCodeContent = this.jobCodeNum + '<br/>' + this.$t('activiti.jobCodeContent') + this.mainPositionList[0].positionDesc.replace(/\n/g, "<br/>")
              } else {
                this.jobCodeContent = this.jobCodeNum + '<br/>' + this.$t('activiti.jobCodeContent')
              }
              this.beforJobCodeNum = this.$t('activiti.jobCodeNum') + this.positionlist[0].positionCode
              if (this.positionlist[0].positionDesc) {
                this.beforJobCodeContent = this.beforJobCodeNum + '<br/>' + this.$t('activiti.jobCodeContent') + this.positionlist[0].positionDesc.replace(/\n/g, "<br/>")
              } else {
                this.beforJobCodeContent = this.beforJobCodeNum + '<br/>' + this.$t('activiti.jobCodeContent')
              }
            }).catch(() => { })
          this.OutletOneabled = false
          this.OutletTwoabled = false
          this.OutletThreeabled = false
          this.OutletFourabled = false
          this.OutletFiveabled = false
        } else {
          this.OutletOneabled = true
          this.OutletTwoabled = true
          this.OutletThreeabled = true
          this.OutletFourabled = true
          this.OutletFiveabled = true
          this.jobCodeContent = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
          this.beforJobCodeContent = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
        }
        if (this.modifyForm.partTimeJobcodeOne !== '' && this.modifyForm.partTimeJobcodeOne !== null && this.modifyForm.partTimeJobcodeOne !== undefined) {
          this.partTimeJobcodeOneabled = false
          // 兼职1网点回显
          this.$request.get('/sys/org/selectOrgByParam',
            {
              orgId: this.dataForm.partTimeOutletOne,
              orgType: this.dataForm.orgType
            }
          ).then((res, total, code, data) => {
            this.outletOneOrglist = JSON.parse(JSON.stringify(res))
            this.orglistOne = JSON.parse(JSON.stringify(res))
          }).catch(() => { })
          // 兼职1职位回显
          this.$request.get(`/sys/commuser/selectPositionByCode`,
            {
              positionCode: this.dataForm.partTimeJobcodeOne + ''
            }).then((res, total, code, data) => {
              this.positionlistOne = JSON.parse(JSON.stringify(res))
              this.newParttimePositionListOne = JSON.parse(JSON.stringify(res))
              this.jobCodeOne = this.$t('activiti.jobCodeNum') + this.newParttimePositionListOne[0].positionCode
              if (this.newParttimePositionListOne[0].positionDesc) {
                this.jobCodeContentOne = this.jobCodeOne + '<br/>' + this.$t('activiti.jobCodeContent') + this.newParttimePositionListOne[0].positionDesc.replace(/\n/g, "<br/>")
              } else {
                this.jobCodeContentOne = this.jobCodeOne + '<br/>' + this.$t('activiti.jobCodeContent')
              }
              this.beforJobCodeOne = this.$t('activiti.jobCodeNum') + this.positionlistOne[0].positionCode
              if (this.positionlistOne[0].positionDesc) {
                this.beforJobCodeContentOne = this.beforJobCodeOne + '<br/>' + this.$t('activiti.jobCodeContent') + this.positionlistOne[0].positionDesc.replace(/\n/g, "<br/>")
              } else {
                this.beforJobCodeContentOne = this.beforJobCodeOne + '<br/>' + this.$t('activiti.jobCodeContent')
              }
            }).catch(() => { })
        } else {
          this.partTimeJobcodeOneabled = true
          this.jobCodeContentOne = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
          this.beforJobCodeContentOne = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
        }
        if (this.modifyForm.partTimeJobcodeTwo !== '' && this.modifyForm.partTimeJobcodeTwo !== null && this.modifyForm.partTimeJobcodeTwo !== undefined) {
          this.partTimeJobcodeTwoabled = false
          // 兼职2网点回显
          this.$request.get('/sys/org/selectOrgByParam',
            {
              orgId: this.dataForm.partTimeOutletTwo,
              orgType: this.dataForm.orgType
            }
          ).then((res, total, code, data) => {
            this.orglistTwo = JSON.parse(JSON.stringify(res))
            this.outletTwoOrglist = JSON.parse(JSON.stringify(res))
          }).catch(() => { })
          // 兼职2职位回显
          this.$request.get(`/sys/commuser/selectPositionByCode`,
            {
              positionCode: this.dataForm.partTimeJobcodeTwo + ''
            }).then((res, total, code, data) => {
              this.positionlistTwo = JSON.parse(JSON.stringify(res))
              this.newParttimePositionListTwo = JSON.parse(JSON.stringify(res))
              this.jobCodeTwo = this.$t('activiti.jobCodeNum') + this.positionlistTwo[0].positionCode
              if (this.newParttimePositionListTwo[0].positionDesc) {
                this.jobCodeContentTwo = this.jobCodeTwo + '<br/>' + this.$t('activiti.jobCodeContent') + this.newParttimePositionListTwo[0].positionDesc.replace(/\n/g, "<br/>")
              } else {
                this.jobCodeContentTwo = this.jobCodeTwo + '<br/>' + this.$t('activiti.jobCodeContent')
              }
              this.beforJobCodeTwo = this.$t('activiti.jobCodeNum') + this.positionlistTwo[0].positionCode
              if (this.newParttimePositionListTwo[0].positionDesc) {
                this.beforJobCodeContentTwo = this.beforJobCodeTwo + '<br/>' + this.$t('activiti.jobCodeContent') + this.newParttimePositionListTwo[0].positionDesc.replace(/\n/g, "<br/>")
              } else {
                this.beforJobCodeContentTwo = this.beforJobCodeTwo + '<br/>' + this.$t('activiti.jobCodeContent')
              }
            }).catch(() => { })
        } else {
          this.partTimeJobcodeTwoabled = true
          this.jobCodeContentTwo = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
          this.beforJobCodeContentTwo = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
        }
        if (this.modifyForm.partTimeJobcodeThree !== '' && this.modifyForm.partTimeJobcodeThree !== null && this.modifyForm.partTimeJobcodeThree !== undefined) {
          this.partTimeJobcodeThreeabled = false
          // 兼职3网点回显
          this.$request.get('/sys/org/selectOrgByParam',
            {
              orgId: this.dataForm.partTimeOutletThree,
              orgType: this.dataForm.orgType
            }
          ).then((res, total, code, data) => {
            this.orglistThree = JSON.parse(JSON.stringify(res))
            this.outletThreeOrglist = JSON.parse(JSON.stringify(res))
          }).catch(() => { })
          // 兼职3职位回显
          this.$request.get(`/sys/commuser/selectPositionByCode`,
            {
              positionCode: this.dataForm.partTimeJobcodeThree + ''
            }).then((res, total, code, data) => {
              this.positionlistThree = JSON.parse(JSON.stringify(res))
              this.newParttimePositionListThree = JSON.parse(JSON.stringify(res))
              this.jobCodeThree = this.$t('activiti.jobCodeNum') + this.positionlistThree[0].positionCode
              if (this.newParttimePositionListThree[0].positionDesc) {
                this.jobCodeContentThree = this.jobCodeThree + '<br/>' + this.$t('activiti.jobCodeContent') + this.newParttimePositionListThree[0].positionDesc.replace(/\n/g, "<br/>")
              } else {
                this.jobCodeContentThree = this.jobCodeThree + '<br/>' + this.$t('activiti.jobCodeContent')
              }
              this.beforJobCodeThree = this.$t('activiti.jobCodeNum') + this.positionlistThree[0].positionCode
              if (this.newParttimePositionListThree[0].positionDesc) {
                this.beforJobCodeContentThree = this.beforJobCodeThree + '<br/>' + this.$t('activiti.jobCodeContent') + this.newParttimePositionListThree[0].positionDesc.replace(/\n/g, "<br/>")
              } else {
                this.beforJobCodeContentThree = this.beforJobCodeThree + '<br/>' + this.$t('activiti.jobCodeContent')
              }
            }).catch(() => { })
        } else {
          this.partTimeJobcodeThreeabled = true
          this.jobCodeContentThree = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
          this.beforJobCodeContentThree = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
        }
        if (this.modifyForm.partTimeJobcodeFour !== '' && this.modifyForm.partTimeJobcodeFour !== null && this.modifyForm.partTimeJobcodeFour !== undefined) {
          this.partTimeJobcodeFourabled = false
          // 兼职4网点回显
          this.$request.get('/sys/org/selectOrgByParam',
            {
              orgId: this.dataForm.partTimeOutletFour,
              orgType: this.dataForm.orgType
            }
          ).then((res, total, code, data) => {
            this.orglistFour = JSON.parse(JSON.stringify(res))
            this.outletFourOrglist = JSON.parse(JSON.stringify(res))
          }).catch(() => { })
          // 兼职4职位回显
          this.$request.get(`/sys/commuser/selectPositionByCode`,
            {
              positionCode: this.dataForm.partTimeJobcodeFour + ''
            }).then((res, total, code, data) => {
              this.positionlistFour = JSON.parse(JSON.stringify(res))
              this.newParttimePositionListFour = JSON.parse(JSON.stringify(res))
              this.jobCodeFour = this.$t('activiti.jobCodeNum') + this.positionlistFour[0].positionCode
              if (this.newParttimePositionListFour[0].positionDesc) {
                this.jobCodeContentFour = this.jobCodeFour + '<br/>' + this.$t('activiti.jobCodeContent') + this.newParttimePositionListFour[0].positionDesc.replace(/\n/g, "<br/>")
              } else {
                this.jobCodeContentFour = this.jobCodeFour + '<br/>' + this.$t('activiti.jobCodeContent')
              }
              this.beforJobCodeFour = this.$t('activiti.jobCodeNum') + this.positionlistFour[0].positionCode
              if (this.newParttimePositionListFour[0].positionDesc) {
                this.beforJobCodeContentFour = this.beforJobCodeFour + '<br/>' + this.$t('activiti.jobCodeContent') + this.newParttimePositionListFour[0].positionDesc.replace(/\n/g, "<br/>")
              } else {
                this.beforJobCodeContentFour = this.beforJobCodeFour + '<br/>' + this.$t('activiti.jobCodeContent')
              }
            }).catch(() => { })
        } else {
          this.partTimeJobcodeFourabled = true
          this.jobCodeContentFour = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
          this.beforJobCodeContentFour = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
        }
        if (this.modifyForm.partTimeJobcodeFive !== '' && this.modifyForm.partTimeJobcodeFive !== null && this.modifyForm.partTimeJobcodeFive !== undefined) {
          this.partTimeJobcodeFiveabled = false
          // 兼职5网点回显
          this.$request.get('/sys/org/selectOrgByParam',
            {
              orgId: this.dataForm.partTimeOutletFive,
              orgType: this.dataForm.orgType
            }
          ).then((res, total, code, data) => {
            this.orglistFive = JSON.parse(JSON.stringify(res))
            this.outletFiveOrglist = JSON.parse(JSON.stringify(res))
          }).catch(() => { })
          // 兼职5职位回显
          this.$request.get(`/sys/commuser/selectPositionByCode`,
            {
              positionCode: this.dataForm.partTimeJobcodeFive + ''
            }).then((res, total, code, data) => {
              this.positionlistFive = JSON.parse(JSON.stringify(res))
              this.newParttimePositionListFive = JSON.parse(JSON.stringify(res))
              this.jobCodeFive = this.$t('activiti.jobCodeNum') + this.positionlistFive[0].positionCode
              if (this.newParttimePositionListFive[0].positionDesc) {
                this.jobCodeContentFive = this.jobCodeFive + '<br/>' + this.$t('activiti.jobCodeContent') + this.newParttimePositionListFive[0].positionDesc.replace(/\n/g, "<br/>")
              } else {
                this.jobCodeContentFive = this.jobCodeFive + '<br/>' + this.$t('activiti.jobCodeContent')
              }
              this.beforJobCodeFive = this.$t('activiti.jobCodeNum') + this.positionlistFive[0].positionCode
              if (this.newParttimePositionListFive[0].positionDesc) {
                this.beforJobCodeContentFive = this.beforJobCodeFive + '<br/>' + this.$t('activiti.jobCodeContent') + this.newParttimePositionListFive[0].positionDesc.replace(/\n/g, "<br/>")
              } else {
                this.beforJobCodeContentFive = this.beforJobCodeFive + '<br/>' + this.$t('activiti.jobCodeContent')
              }
            }).catch(() => { })
        } else {
          this.partTimeJobcodeFiveabled = true
          this.jobCodeContentFive = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
          this.beforJobCodeContentFive = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
        }
        if (this.modifyForm.partTimeJobcodeOne === '' || this.modifyForm.partTimeJobcodeOne === null || this.modifyForm.partTimeJobcodeOne === undefined) {
          this.$request.post('/sys/commuser/queryPartOutlet',
            {
              orgId: this.modifyForm.orgId,
              name: ''
            }
          ).then((res, total, code, data) => {
            this.outletOneOrglist = res
            // this.outletTwoOrglist = res
            console.log(this.outletOneOrglist)
          }).catch(() => { })
        }
        if (this.modifyForm.partTimeJobcodeTwo === '' || this.modifyForm.partTimeJobcodeTwo === null || this.modifyForm.partTimeJobcodeTwo === undefined) {
          this.$request.post('/sys/commuser/queryPartOutlet',
            {
              orgId: this.modifyForm.orgId,
              name: ''
            }
          ).then((res, total, code, data) => {
            // this.outletOneOrglist = res
            this.outletTwoOrglist = res
            console.log(this.outletOneOrglist)
          }).catch(() => { })
        }
        if (this.modifyForm.partTimeJobcodeThree === '' || this.modifyForm.partTimeJobcodeThree === null || this.modifyForm.partTimeJobcodeThree === undefined) {
          this.$request.post('/sys/commuser/queryPartOutlet',
            {
              orgId: this.modifyForm.orgId,
              name: ''
            }
          ).then((res, total, code, data) => {
            this.outletThreeOrglist = res
            console.log(this.outletThreeOrglist)
          }).catch(() => { })
        }
        if (this.modifyForm.partTimeJobcodeFour === '' || this.modifyForm.partTimeJobcodeFour === null || this.modifyForm.partTimeJobcodeFour === undefined) {
          this.$request.post('/sys/commuser/queryPartOutlet',
            {
              orgId: this.modifyForm.orgId,
              name: ''
            }
          ).then((res, total, code, data) => {
            this.outletFourOrglist = res
            console.log(this.outletFourOrglist)
          }).catch(() => { })
        }
        if (this.modifyForm.partTimeJobcodeFive === '' || this.modifyForm.partTimeJobcodeFive === null || this.modifyForm.partTimeJobcodeFive === undefined) {
          this.$request.post('/sys/commuser/queryPartOutlet',
            {
              orgId: this.modifyForm.orgId,
              name: ''
            }
          ).then((res, total, code, data) => {
            this.outletFiveOrglist = res
            console.log(this.outletFiveOrglist)
          }).catch(() => { })
        }
      }).catch(() => { })
    },
    // 兼职网点1
    outletOnequerySearch(queryString) {
      console.log(queryString)
      this.$request.post('/sys/commuser/queryPartOutlet',
        {
          orgId: this.modifyForm.orgId,
          name: queryString
        }
      ).then((res, total, code, data) => {
        this.outletOneOrglist = res
        console.log(this.outletOneOrglist)
      }).catch(() => { })
    },
    // 兼职网点2
    outletTwoquerySearch(queryString) {
      this.$request.post('/sys/commuser/queryPartOutlet',
        {
          orgId: this.modifyForm.orgId,
          name: queryString
        }
      ).then((res, total, code, data) => {
        this.outletTwoOrglist = res
      }).catch(() => { })
    },
    // 兼职网点3
    outletThreequerySearch(queryString) {
      this.$request.post('/sys/commuser/queryPartOutlet',
        {
          orgId: this.modifyForm.orgId,
          name: queryString
        }
      ).then((res, total, code, data) => {
        this.outletThreeOrglist = res
      }).catch(() => { })
    },
    // 兼职网点4
    outletFourquerySearch(queryString) {
      this.$request.post('/sys/commuser/queryPartOutlet',
        {
          orgId: this.modifyForm.orgId,
          name: queryString
        }
      ).then((res, total, code, data) => {
        this.outletFourOrglist = res
      }).catch(() => { })
    },
    // 兼职网点5
    outletFivequerySearch(queryString) {
      this.$request.post('/sys/commuser/queryPartOutlet',
        {
          orgId: this.modifyForm.orgId,
          name: queryString
        }
      ).then((res, total, code, data) => {
        this.outletFiveOrglist = res
      }).catch(() => { })
    },
    // 主职的list
    jobCodequerySearch(queryString) {
      this.$request.post('/sys/commuser/commPositionByParam',
        {
          orgId: this.modifyForm.orgId,
          positionName: queryString,
          orgType: '60'
        }
      ).then((res, total, code, data) => {
        this.mainPositionList = res
      }).catch(() => { })
      if (this.modifyForm.jobCode === '' || this.modifyForm.jobCode === undefined || this.modifyForm.jobCode === null) {
        this.jobCodeContentClean()
      }
    },
    // 转岗后兼职1
    partTimeJobcodeOnequerySearch(queryString) {
      this.$request.post('/sys/commuser/commPositionTimeJob',
        {
          positionCode: this.modifyForm.jobCode,
          positionName: queryString,
          orgId: this.modifyForm.partTimeOutletOne
        }
      ).then((res, total, code, data) => {
        this.newParttimePositionListOne = res
      }).catch(() => { })
      if (this.modifyForm.partTimeJobcodeOne === '' || this.modifyForm.partTimeJobcodeOne === undefined || this.modifyForm.partTimeJobcodeOne === null) {
        this.jobCodeContentCleanOne()
      }
    },
    // 转岗后兼职2
    partTimeJobcodeTwoquerySearch(queryString) {
      this.$request.post('/sys/commuser/commPositionTimeJob',
        {
          positionCode: this.modifyForm.jobCode,
          positionName: queryString,
          orgId: this.modifyForm.partTimeOutletTwo
        }
      ).then((res, total, code, data) => {
        this.newParttimePositionListTwo = res
      }).catch(() => { })
      if (this.modifyForm.partTimeJobcodeTwo === '' || this.modifyForm.partTimeJobcodeTwo === undefined || this.modifyForm.partTimeJobcodeTwo === null) {
        this.jobCodeContentCleanTwo()
      }
    },
    // 转岗后兼职3
    partTimeJobcodeThreequerySearch(queryString) {
      this.$request.post('/sys/commuser/commPositionTimeJob',
        {
          positionCode: this.modifyForm.jobCode,
          positionName: queryString,
          orgId: this.modifyForm.partTimeOutletThree
        }
      ).then((res, total, code, data) => {
        this.newParttimePositionListThree = res
      }).catch(() => { })
      if (this.modifyForm.partTimeJobcodeThree === '' || this.modifyForm.partTimeJobcodeThree === undefined || this.modifyForm.partTimeJobcodeThree === null) {
        this.jobCodeContentCleanThree()
      }
    },
    // 转岗后兼职4
    partTimeJobcodeFourquerySearch(queryString) {
      this.$request.post('/sys/commuser/commPositionTimeJob',
        {
          positionCode: this.modifyForm.jobCode,
          positionName: queryString,
          orgId: this.modifyForm.partTimeOutletFour
        }
      ).then((res, total, code, data) => {
        this.newParttimePositionListFour = res
      }).catch(() => { })
      if (this.modifyForm.partTimeJobcodeFour === '' || this.modifyForm.partTimeJobcodeFour === undefined || this.modifyForm.partTimeJobcodeFour === null) {
        this.jobCodeContentCleanFour()
      }
    },
    // 转岗后兼职5
    partTimeJobcodeFivequerySearch(queryString) {
      this.$request.post('/sys/commuser/commPositionTimeJob',
        {
          positionCode: this.modifyForm.jobCode,
          positionName: queryString,
          orgId: this.modifyForm.partTimeOutletFive
        }
      ).then((res, total, code, data) => {
        this.newParttimePositionListFive = res
      }).catch(() => { })
      if (this.modifyForm.partTimeJobcodeFive === '' || this.modifyForm.partTimeJobcodeFive === undefined || this.modifyForm.partTimeJobcodeFive === null) {
        this.jobCodeContentCleanFive()
      }
    },
    // 转岗后网点list
    mainOutletOnequerySearch(queryString) {
      this.$request.post('/sys/commuser/queryPartOutlet',
        {
          orgId: this.dataForm.orgId,
          name: queryString
        }).then((res, total, code, data) => {
          this.orglist = res
        }).catch(() => { })
    },
    // 主要职位
    jobCode() {
      this.jobCode0 = 1
      this.partTimeJobcodeOneabled = true
      this.partTimeJobcodeTwoabled = true
      this.partTimeJobcodeThreeabled = true
      this.partTimeJobcodeFourabled = true
      this.partTimeJobcodeFiveabled = true
      this.modifyForm.partTimeOutletOne = ''
      this.modifyForm.partTimeOutletTwo = ''
      this.modifyForm.partTimeOutletThree = ''
      this.modifyForm.partTimeOutletFour = ''
      this.modifyForm.partTimeOutletFive = ''
      this.modifyForm.partTimeJobcodeOne = ''
      this.modifyForm.partTimeJobcodeTwo = ''
      this.modifyForm.partTimeJobcodeThree = ''
      this.modifyForm.partTimeJobcodeFour = ''
      this.modifyForm.partTimeJobcodeFive = ''
      this.jobCodeOne = this.$t('activiti.jobCodeNum')
      this.jobCodeContentOne = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
      this.jobCodeTwo = this.$t('activiti.jobCodeNum')
      this.jobCodeContentTwo = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
      this.jobCodeThree = this.$t('activiti.jobCodeNum')
      this.jobCodeContentThree = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
      this.jobCodeFour = this.$t('activiti.jobCodeNum')
      this.jobCodeContentFour = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
      this.jobCodeFive = this.$t('activiti.jobCodeNum')
      this.jobCodeContentFive = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
      if (this.modifyForm.orgId === '' || this.modifyForm.orgId === null) {
        this.jobCodeContentCleanOne()
        this.jobCodeContentCleanTwo()
        this.jobCodeContentCleanThree()
        this.jobCodeContentCleanFour()
        this.jobCodeContentCleanFive()
        return false
      }
      if (this.modifyForm.jobCode === '' || this.modifyForm.jobCode === null || this.modifyForm.jobCode === undefined) {
        this.OutletOneabled = true
        this.OutletTwoabled = true
        this.OutletThreeabled = true
        this.OutletFourabled = true
        this.OutletFiveabled = true
        this.jobCodeContentClean()
      } else {
        this.isDisable = true
        if (this.modifyForm.orgType === '60' || this.modifyForm.orgType === '50') {
          this.$request.get('/sys/commuser/needEffectiveEvaluation',
            {
              positionCode: this.modifyForm.jobCode,
              userId: this.dataForm.userId
            }).then((res, tota,code, data) => {
              if (code !== 1) {
                let message = '当前AC测评服务不可用，请稍后再试。'
                this.$alert(message, this.$t('prompt.title')).then(() => { }).catch(() => { })
                this.modifyForm.jobCode = ''
                this.OutletOneabled = true
                this.OutletTwoabled = true
                this.OutletThreeabled = true
                this.OutletFourabled = true
                this.OutletFiveabled = true
                this.isDisable = false
              } else if (code === 1 && res === 0) {
                let message = '该候选人暂无有效的关键管理职位评测记录，不可分配正式职位，请先分配非特殊职位。前往人才发展-评估中心-邀请候选人测评，可发起测评邀请。'
                this.$alert(message, this.$t('prompt.title')).then(() => { }).catch(() => { })
                this.modifyForm.jobCode = ''
                this.OutletOneabled = true
                this.OutletTwoabled = true
                this.OutletThreeabled = true
                this.OutletFourabled = true
                this.OutletFiveabled = true
                this.isDisable = false
              } else if (code === 1 && res > 0) {
                this.OutletOneabled = false
                this.OutletTwoabled = false
                this.OutletThreeabled = false
                this.OutletFourabled = false
                this.OutletFiveabled = false
                this.$request.get('/sys/commuser/singlePosition',
                  {
                    positionCode: this.modifyForm.jobCode,
                    outletId: this.modifyForm.orgId,
                    userId: this.dataForm.userId
                  }
                ).then((res, total, code, data) => {
                  if (res.singlePosition === 1) {
                    // 提示当前岗位单店单岗，已被占用不可选择
                    let entry = this.orglist.find(item => {
                      if (item.orgId === this.modifyForm.orgId) {
                        return item
                      }
                    })
                    let message = '当前岗位已经被 “' + entry.name + '” 的 “' + res.userName + '(' + res.userCode + ')' + '” 占用，不可选择'
                    this.$alert(message, this.$t('prompt.title')).then(() => { }).catch(() => { })
                    this.modifyForm.jobCode = ''
                    this.OutletOneabled = true
                    this.OutletTwoabled = true
                    this.OutletThreeabled = true
                    this.OutletFourabled = true
                    this.OutletFiveabled = true
                    this.isDisable = false
                  } else {
                    this.isDisable = false
                    this.jobCodeContentChange(this.modifyForm.jobCode)
                  }
                }).catch(() => { })
              }
            })
        } else {
                this.OutletOneabled = false
                this.OutletTwoabled = false
                this.OutletThreeabled = false
                this.OutletFourabled = false
                this.OutletFiveabled = false
          this.$request.get('/sys/commuser/singlePosition',
            {
              positionCode: this.modifyForm.jobCode,
              outletId: this.modifyForm.orgId,
              userId: this.dataForm.userId
            }
          ).then((res, total, code, data) => {
            if (res.singlePosition === 1) {
              // 提示当前岗位单店单岗，已被占用不可选择
              let entry = this.orglist.find(item => {
                if (item.orgId === this.modifyForm.orgId) {
                  return item
                }
              })
              let message = '当前岗位已经被 “' + entry.name + '” 的 “' + res.userName + '(' + res.userCode + ')' + '” 占用，不可选择'
              this.$alert(message, this.$t('prompt.title')).then(() => { }).catch(() => { })
              this.modifyForm.jobCode = '' 
              this.OutletOneabled = true
              this.OutletTwoabled = true
              this.OutletThreeabled = true
              this.OutletFourabled = true
              this.OutletFiveabled = true
              this.isDisable = false
            } else {
              this.isDisable = false
              this.jobCodeContentChange(this.modifyForm.jobCode)
            }
          }).catch(() => { })
        }
      }
      if (this.modifyForm.jobCode === '' || this.modifyForm.jobCode === undefined || this.modifyForm.jobCode === null) {
        this.$request.post('/sys/commuser/commPositionByParam',
          {
            orgId: this.modifyForm.orgId,
            positionName: '',
            orgType: '60'
          }
        ).then((res, total, code, data) => {
          this.mainPositionList = res
        }).catch(() => { })
      }
      // this.jobCodeChange()
      this.jobCodeContentCleanOne()
      this.jobCodeContentCleanTwo()
      this.jobCodeContentCleanThree()
      this.jobCodeContentCleanFour()
      this.jobCodeContentCleanFive()
    },
    // 兼职1
    partTimeJobCodeOneTest() {
      this.jobCode0 = 1
      this.partTimeJobcodeOneabled = true
      this.partTimeJobcodeTwoabled = true
      // this.modifyForm.partTimeOutletOne = ''
      // this.modifyForm.partTimeOutletTwo = ''
      // this.modifyForm.partTimeJobcodeOne = ''
      // this.modifyForm.partTimeJobcodeTwo = ''
      this.jobCodeOne = this.$t('activiti.jobCodeNum')
      this.jobCodeContentOne = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
      this.jobCodeTwo = this.$t('activiti.jobCodeNum')
      this.jobCodeContentTwo = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
      if (this.modifyForm.orgId === '' || this.modifyForm.orgId === null) {
        // this.jobCodeChange()
        this.jobCodeContentCleanOne()
        this.jobCodeContentCleanTwo()
        return false
      }
      if (this.modifyForm.jobCode === '' || this.modifyForm.jobCode === null || this.modifyForm.jobCode === undefined) {
        this.OutletTwoabled = true
        this.OutletOneabled = true
        this.jobCodeContentClean()
      } else {
        this.isDisable = true
        if (this.modifyForm.orgType === '60' || this.modifyForm.orgType === '50') {
          this.$request.get('/sys/commuser/needEffectiveEvaluation',
            {
              positionCode: this.modifyForm.partTimeJobcodeOne,
              userId: this.dataForm.userId
            }).then((res, tota,code, data) => {
              if (code !== 1) {
                let message = '当前AC测评服务不可用，请稍后再试。'
                this.$alert(message, this.$t('prompt.title')).then(() => { }).catch(() => { })
                this.modifyForm.partTimeJobcodeOne = ''
                // this.OutletTwoabled = true
                // this.OutletOneabled = true
                this.isDisable = false
              } else if (code === 1 && res === 0) {
                let message = '该候选人暂无有效的关键管理职位评测记录，不可分配正式职位，请先分配非特殊职位。前往人才发展-评估中心-邀请候选人测评，可发起测评邀请。'
                this.$alert(message, this.$t('prompt.title')).then(() => { }).catch(() => { })
                this.modifyForm.partTimeJobcodeOne = ''
                // this.OutletTwoabled = true
                // this.OutletOneabled = true
                this.isDisable = false
              } else if (code === 1 && res > 0) {
                // this.OutletTwoabled = false
                // this.OutletOneabled = false
                this.$request.get('/sys/commuser/singlePosition',
                  {
                    positionCode: this.modifyForm.partTimeJobcodeOne,
                    outletId: this.modifyForm.orgId,
                    userId: this.dataForm.userId
                  }
                ).then((res, total, code, data) => {
                  if (res.singlePosition === 1) {
                    // 提示当前岗位单店单岗，已被占用不可选择
                    let entry = this.orglist.find(item => {
                      if (item.orgId === this.modifyForm.orgId) {
                        return item
                      }
                    })
                    let message = '当前岗位已经被 “' + entry.name + '” 的 “' + res.userName + '(' + res.userCode + ')' + '” 占用，不可选择'
                    this.$alert(message, this.$t('prompt.title')).then(() => { }).catch(() => { })
                    this.modifyForm.partTimeJobcodeOne = ''
                    // this.OutletTwoabled = true
                    // this.OutletOneabled = true
                    this.isDisable = false
                  } else {
                    this.isDisable = false
                    this.jobCodeContentChangeOne(this.modifyForm.jobCode)
                  }
                }).catch(() => { })
              }
            })
        } else {
          // this.OutletTwoabled = false
          // this.OutletOneabled = false
          this.$request.get('/sys/commuser/singlePosition',
            {
              positionCode: this.modifyForm.partTimeJobcodeOne,
              outletId: this.modifyForm.orgId,
              userId: this.dataForm.userId
            }
          ).then((res, total, code, data) => {
            if (res.singlePosition === 1) {
              // 提示当前岗位单店单岗，已被占用不可选择
              let entry = this.orglist.find(item => {
                if (item.orgId === this.modifyForm.orgId) {
                  return item
                }
              })
              let message = '当前岗位已经被 “' + entry.name + '” 的 “' + res.userName + '(' + res.userCode + ')' + '” 占用，不可选择'
              this.$alert(message, this.$t('prompt.title')).then(() => { }).catch(() => { })
              this.modifyForm.jobCode = ''
              this.OutletTwoabled = true
              this.OutletOneabled = true
              this.isDisable = false
            } else {
              this.isDisable = false
              this.jobCodeContentChange(this.modifyForm.jobCode)
            }
          }).catch(() => { })
        }
      }
      if (this.modifyForm.jobCode === '' || this.modifyForm.jobCode === undefined || this.modifyForm.jobCode === null) {
        this.$request.post('/sys/commuser/commPositionByParam',
          {
            orgId: this.modifyForm.orgId,
            positionName: '',
            orgType: '60'
          }
        ).then((res, total, code, data) => {
          this.mainPositionList = res
        }).catch(() => { })
      }
      // this.jobCodeChange()
      this.jobCodeContentCleanOne()
      this.jobCodeContentCleanTwo()
    },
    // 校验是否无效测评
    jobLimit(val) {
      if (val) {
        let positionId = ''
        this.mainPositionList.forEach((item) => {
          if (item.positionCode === val) {
            positionId = item.positionId
          }
        })
        this.isLimitTest(positionId)
      }
    },
    // 是否限制测评
    isLimitTest(val) {
      this.$request.post(
        '/acdc/restrict/checkRecruitment',
        {
          jobId: val,
          userId: this.dataForm.userId
        }
      ).then((res) => {
        if (res) {
          if (res.restrictFlag) {
            this.limitShow = true
            this.isLimit = res.restrictFlag
            this.factoryDesc = res.remark
          } else {
            // 先判断是否无效测评
            this.jobCode()
          }
        }
      })
    },
    // 是否限制测评
    isLimitPartOneTest(val) {
      this.$request.post(
        '/acdc/restrict/checkRecruitment',
        {
          jobId: val,
          userId: this.dataForm.userId
        }
      ).then((res) => {
        if (res) {
          if (res.restrictFlag) {
            this.limitShow = true
            this.isLimit = res.restrictFlag
            this.factoryDesc = res.remark
          } else {
            // 先判断是否无效测评
            this.partTimeJobCodeOneTest()
          }
        }
      })
    },
    closeLimitModal() {
      this.limitShow = false
      this.factoryDesc = ''
      this.modifyForm.jobCode = ''
    },
    orgIdChange() {
      this.jobCode0 = 1
      this.jobCodeabled = false
      this.partTimeJobcodeOneabled = true
      this.partTimeJobcodeTwoabled = true
      this.partTimeJobcodeThreeabled = true
      this.partTimeJobcodeFourabled = true
      this.partTimeJobcodeFiveabled = true
      this.modifyForm.jobCode = ''
      this.modifyForm.partTimeOutletOne = ''
      this.modifyForm.partTimeOutletTwo = ''
      this.modifyForm.partTimeOutletThree = ''
      this.modifyForm.partTimeOutletFour = ''
      this.modifyForm.partTimeOutletFive = ''
      this.modifyForm.partTimeJobcodeOne = ''
      this.modifyForm.partTimeJobcodeTwo = ''
      this.modifyForm.partTimeJobcodeThree = ''
      this.modifyForm.partTimeJobcodeFour = ''
      this.modifyForm.partTimeJobcodeFive = ''
      this.$refs.modifyForm.clearValidate('partTimeJobcodeOne')
      this.$refs.modifyForm.clearValidate('partTimeJobcodeTwo')
      this.$refs.modifyForm.clearValidate('partTimeJobcodeThree')
      this.$refs.modifyForm.clearValidate('partTimeJobcodeFour')
      this.$refs.modifyForm.clearValidate('partTimeJobcodeFive')

      this.$request.post('/sys/commuser/queryPartOutlet',
        {
          orgId: this.dataForm.orgId,
          name: ''
        }).then((res, total, code, data) => {
          this.orglist = res
        }).catch(() => { })
      if (this.modifyForm.orgId !== '' && this.modifyForm.orgId !== null && this.modifyForm.orgId !== undefined) {
        this.$request.post('/sys/commuser/commPositionByParam',
          {
            orgId: this.modifyForm.orgId,
            positionName: '',
            orgType: '60'
          }
        ).then((res, total, code, data) => {
          this.mainPositionList = res
        }).catch(() => { })
        this.$request.post('/sys/commuser/queryPartOutlet',
          {
            orgId: this.modifyForm.orgId,
            name: ''
          }
        ).then((res, total, code, data) => {
          this.outletOneOrglist = res
          this.outletTwoOrglist = res
          this.outletThreeOrglist = res
          this.outletFourOrglist = res
          this.outletFiveOrglist = res
          console.log(this.outletOneOrglist)
        }).catch(() => { })
      } else {
        this.jobCodeabled = true
        this.OutletOneabled = true
        this.OutletTwoabled = true
        this.OutletThreeabled = true
        this.OutletFourabled = true
        this.OutletFiveabled = true
        this.$nextTick(() => {
          this.$refs.modifyForm.clearValidate('jobCode')
        })
      }
      this.jobCodeContentClean()
      this.jobCodeContentCleanOne()
      this.jobCodeContentCleanTwo()
      this.jobCodeContentCleanThree()
      this.jobCodeContentCleanFour()
      this.jobCodeContentCleanFive()
    },
    // 网点一
    changeOutletOne() {
      this.jobCode1 = 1
      this.modifyForm.partTimeJobcodeOne = ''
      if (this.modifyForm.partTimeOutletOne === '' || this.modifyForm.partTimeOutletOne === null || this.modifyForm.partTimeOutletOne === undefined) {
        this.partTimeJobcodeOneabled = true
        this.modifyForm.partTimeJobcodeOne = ''
        this.$refs.modifyForm.clearValidate('partTimeJobcodeOne')
      } else {
        this.partTimeJobcodeOneabled = false
      }
      this.jobCodeContentCleanOne()
      if (this.modifyForm.partTimeOutletOne !== '' && this.modifyForm.partTimeOutletOne !== null && this.modifyForm.partTimeOutletOne !== undefined) {
        this.$request.post('/sys/commuser/commPositionTimeJob',
          {
            positionCode: this.modifyForm.jobCode,
            positionName: '',
            orgId: this.modifyForm.partTimeOutletOne
          }
        ).then((res, total, code, data) => {
          this.newParttimePositionListOne = res
        }).catch(() => { })
      }
    },
    // 网点二
    changeOutletTwo() {
      this.jobCode2 = 1
      this.modifyForm.partTimeJobcodeTwo = ''
      if (this.modifyForm.partTimeOutletTwo === '' || this.modifyForm.partTimeOutletTwo === null || this.modifyForm.partTimeOutletTwo === undefined) {
        this.partTimeJobcodeTwoabled = true
        this.modifyForm.partTimeJobcodeTwo = ''
        this.$refs.modifyForm.clearValidate('partTimeJobcodeTwo')
      } else {
        this.partTimeJobcodeTwoabled = false
      }
      this.jobCodeContentCleanTwo()
      if (this.modifyForm.partTimeOutletTwo !== '' && this.modifyForm.partTimeOutletTwo !== null && this.modifyForm.partTimeOutletTwo !== undefined) {
        this.$request.post('/sys/commuser/commPositionTimeJob',
          {
            positionCode: this.modifyForm.jobCode,
            positionName: '',
            orgId: this.modifyForm.partTimeOutletTwo
          }
        ).then((res, total, code, data) => {
          this.newParttimePositionListTwo = res
        }).catch(() => { })
      }
    },
    // 网点三
    changeOutletThree() {
      this.jobCode3 = 1
      this.modifyForm.partTimeJobcodeThree = ''
      if (this.modifyForm.partTimeOutletThree === '' || this.modifyForm.partTimeOutletThree === null || this.modifyForm.partTimeOutletThree === undefined) {
        this.partTimeJobcodeThreeabled = true
        this.modifyForm.partTimeJobcodeThree = ''
        this.$refs.modifyForm.clearValidate('partTimeJobcodeThree')
      } else {
        this.partTimeJobcodeThreeabled = false
      }
      this.jobCodeContentCleanThree()
      if (this.modifyForm.partTimeOutletThree !== '' && this.modifyForm.partTimeOutletThree !== null && this.modifyForm.partTimeOutletThree !== undefined) {
        this.$request.post('/sys/commuser/commPositionTimeJob',
          {
            positionCode: this.modifyForm.jobCode,
            positionName: '',
            orgId: this.modifyForm.partTimeOutletThree
          }
        ).then((res, total, code, data) => {
          this.newParttimePositionListThree = res
        }).catch(() => { })
      }
    },
    // 网点四
    changeOutletFour() {
      this.jobCode4 = 1
      this.modifyForm.partTimeJobcodeFour = ''
      if (this.modifyForm.partTimeOutletFour === '' || this.modifyForm.partTimeOutletFour=== null || this.modifyForm.partTimeOutletFour === undefined) {
        this.partTimeJobcodeFourabled = true
        this.modifyForm.partTimeJobcodeFour = ''
        this.$refs.modifyForm.clearValidate('partTimeJobcodeFour')
      } else {
        this.partTimeJobcodeFourabled = false
      }
      this.jobCodeContentCleanFour()
      if (this.modifyForm.partTimeOutletFour !== '' && this.modifyForm.partTimeOutletFour !== null && this.modifyForm.partTimeOutletFour !== undefined) {
        this.$request.post('/sys/commuser/commPositionTimeJob',
          {
            positionCode: this.modifyForm.jobCode,
            positionName: '',
            orgId: this.modifyForm.partTimeOutletFour
          }
        ).then((res, total, code, data) => {
          this.newParttimePositionListFour = res
        }).catch(() => { })
      }
    },
    // 网点五
    changeOutletFive() {
      this.jobCode5 = 1
      this.modifyForm.partTimeJobcodeFive = ''
      if (this.modifyForm.partTimeOutletFive === '' || this.modifyForm.partTimeOutletFive === null || this.modifyForm.partTimeOutletFive === undefined) {
        this.partTimeJobcodeFiveabled = true
        this.modifyForm.partTimeJobcodeFive = ''
        this.$refs.modifyForm.clearValidate('partTimeJobcodeFive')
      } else {
        this.partTimeJobcodeFiveabled = false
      }
      this.jobCodeContentCleanFive()
      if (this.modifyForm.partTimeOutletFive !== '' && this.modifyForm.partTimeOutletFive !== null && this.modifyForm.partTimeOutletFive !== undefined) {
        this.$request.post('/sys/commuser/commPositionTimeJob',
          {
            positionCode: this.modifyForm.jobCode,
            positionName: '',
            orgId: this.modifyForm.partTimeOutletFive
          }
        ).then((res, total, code, data) => {
          this.newParttimePositionListFive = res
        }).catch(() => { })
      }
    },
    // 兼职一职位描述+不能重复+单店单岗
    parttimejobRepeatOne(el) {
      this.jobCode1 = 1
      
      let positionId = ''
        this.newParttimePositionListOne.forEach((item) => {
          if (item.positionCode === el) {
            positionId = item.positionId
          }
        })

        if(!el){return;}
        
      this.$request.get('/sys/commuser/needEffectiveEvaluation',
            {
              positionCode: el,
              userId: this.dataForm.userId
            }).then((res, tota,code, data) => {
              if (code !== 1) {
                let message = '当前AC测评服务不可用，请稍后再试。'
                this.$alert(message, this.$t('prompt.title')).then(() => { }).catch(() => { })
                this.modifyForm.partTimeJobcodeOne = ''
                this.isDisable = false
              } else if (code === 1 && res === 0) {
                let message = '该候选人暂无有效的关键管理职位评测记录，不可分配正式职位，请先分配非特殊职位。前往人才发展-评估中心-邀请候选人测评，可发起测评邀请。'
                this.$alert(message, this.$t('prompt.title')).then(() => { }).catch(() => { })
                this.modifyForm.partTimeJobcodeOne = ''
                this.isDisable = false
              }else{
                this.$request.get('/sys/commuser/singlePosition',
                  {
                    positionCode: el,
                    outletId: this.modifyForm.partTimeOutletOne,
                    userId: this.dataForm.userId
                  }
                ).then((res, total, code, data) => {
                  if (res.singlePosition === 1) {
                    // 提示当前岗位单店单岗，已被占用不可选择
                    let entry = this.outletOneOrglist.find(item => {
                      if (item.orgId === this.modifyForm.partTimeOutletOne) {
                        return item
                      }
                    })
                    let message = '当前岗位已经被 “' + entry.name + '” 的 “' + res.userName + '(' + res.userCode + ')' + '” 占用，不可选择'
                    this.$alert(message, this.$t('prompt.title')).then(() => { }).catch(() => { })
                    this.modifyForm.partTimeJobcodeOne = ''
                  } else {
                    // 判断职位是否重复
                    if(this.checkRepeat()){
                       this.$alert(this.$t('user.verificationparttime'), this.$t('prompt.title')).then(() => {
                      }).catch(() => { })
                      this.modifyForm.partTimeJobcodeOne = ''
                    }
                    else{
                      this.jobCodeContentChangeOne(this.modifyForm.partTimeJobcodeOne)
                    }
                    /*
                    // 兼职不能与主职重复
                    if (this.modifyForm.partTimeJobcodeOne === this.modifyForm.jobCode && this.modifyForm.partTimeJobcodeOne !== '' && this.modifyForm.partTimeJobcodeOne !== null && this.modifyForm.partTimeJobcodeOne !== undefined) {
                      this.$alert(this.$t('user.verificationparttimeJobCode'), this.$t('prompt.title')).then(() => {
                      }).catch(() => { })
                      this.modifyForm.partTimeJobcodeOne = ''
                    } else if (this.modifyForm.partTimeJobcodeOne === this.modifyForm.partTimeJobcodeTwo && this.modifyForm.partTimeJobcodeTwo !== '' && this.modifyForm.partTimeJobcodeTwo !== null && this.modifyForm.partTimeJobcodeTwo !== undefined) {
                      // 兼职互相不能重复
                      this.$alert(this.$t('user.verificationparttime'), this.$t('prompt.title')).then(() => {
                      }).catch(() => { })
                      this.modifyForm.partTimeJobcodeOne = ''
                    } else {
                      this.jobCodeContentChangeOne(this.modifyForm.partTimeJobcodeOne)
                    }
                    */
                  }
                }).catch(() => { })
                    if (this.modifyForm.partTimeJobcodeOne === '' || this.modifyForm.partTimeJobcodeOne === undefined || this.modifyForm.partTimeJobcodeOne === null) {
                      this.$request.post('/sys/commuser/commPositionTimeJob',
                        {
                          positionCode: this.modifyForm.jobCode,
                          positionName: '',
                          orgId: this.modifyForm.partTimeOutletOne
                        }
                      ).then((res, total, code, data) => {
                        this.newParttimePositionListOne = res
                      }).catch(() => { })
                    }
              }

            })
    },
    // 兼职二职位描述+不能重复+单店单岗
    parttimejobRepeatTwo(el) {
      this.jobCode2 = 1
      let positionId = ''
        this.newParttimePositionListOne.forEach((item) => {
          if (item.positionCode === el) {
            positionId = item.positionId
          }
        })

        if(!el){return;}
      this.$request.get('/sys/commuser/needEffectiveEvaluation',
            {
              positionCode: el,
              userId: this.dataForm.userId
            }).then((res, tota,code, data) => {
              if (code !== 1) {
                let message = '当前AC测评服务不可用，请稍后再试。'
                this.$alert(message, this.$t('prompt.title')).then(() => { }).catch(() => { })
                this.modifyForm.partTimeJobcodeTwo = ''
                this.isDisable = false
              } else if (code === 1 && res === 0) {
                let message = '该候选人暂无有效的关键管理职位评测记录，不可分配正式职位，请先分配非特殊职位。前往人才发展-评估中心-邀请候选人测评，可发起测评邀请。'
                this.$alert(message, this.$t('prompt.title')).then(() => { }).catch(() => { })
                this.modifyForm.partTimeJobcodeTwo = ''
                this.isDisable = false
              }else{
                this.$request.get('/sys/commuser/singlePosition',
                  {
                    positionCode: el,
                    outletId: this.modifyForm.partTimeOutletTwo,
                    userId: this.dataForm.userId
                  }
                ).then((res, total, code, data) => {
                  if (res.singlePosition === 1) {
                    // 提示当前岗位单店单岗，已被占用不可选择
                    // 提示当前岗位单店单岗，已被占用不可选择
                    let entry = this.outletTwoOrglist.find(item => {
                      if (item.orgId === this.modifyForm.partTimeOutletTwo) {
                        return item
                      }
                    })
                    let message = '当前岗位已经被 “' + entry.name + '” 的 “' + res.userName + '(' + res.userCode + ')' + '” 占用，不可选择'
                    this.$alert(message, this.$t('prompt.title')).then(() => { }).catch(() => { })
                    this.modifyForm.partTimeJobcodeTwo = ''
                  } else {
                    // 判断职位是否重复
                    if(this.checkRepeat()){
                       this.$alert(this.$t('user.verificationparttime'), this.$t('prompt.title')).then(() => {
                      }).catch(() => { })
                      this.modifyForm.partTimeJobcodeTwo = ''
                    }
                    else{
                      this.jobCodeContentChangeTwo(this.modifyForm.partTimeJobcodeTwo)
                    }
                    /*
                    // 兼职不能与主职重复
                    if (this.modifyForm.partTimeJobcodeTwo === this.modifyForm.jobCode && this.modifyForm.partTimeJobcodeTwo !== '' && this.modifyForm.partTimeJobcodeTwo !== null && this.modifyForm.partTimeJobcodeTwo !== undefined) {
                      this.$alert(this.$t('user.verificationparttimeJobCode'), this.$t('prompt.title')).then(() => {
                      }).catch(() => { })
                      this.modifyForm.partTimeJobcodeOne = ''
                    } else if (this.modifyForm.partTimeJobcodeTwo === this.modifyForm.partTimeJobcodeOne && this.modifyForm.partTimeJobcodeOne !== '' && this.modifyForm.partTimeJobcodeOne !== null && this.modifyForm.partTimeJobcodeOne !== undefined) {
                      // 兼职互相不能重复
                      this.$alert(this.$t('user.verificationparttime'), this.$t('prompt.title')).then(() => {
                      }).catch(() => { })
                      this.modifyForm.partTimeJobcodeTwo = ''
                    } else {
                      this.jobCodeContentChangeTwo(this.modifyForm.partTimeJobcodeTwo)
                    }
                    */
                  }
                }).catch(() => { })
                if (this.modifyForm.partTimeJobcodeTwo === '' || this.modifyForm.partTimeJobcodeTwo === undefined || this.modifyForm.partTimeJobcodeTwo === null) {
                  this.$request.post('/sys/commuser/commPositionTimeJob',
                    {
                      positionCode: this.modifyForm.jobCode,
                      positionName: '',
                      orgId: this.modifyForm.partTimeOutletTwo
                    }
                  ).then((res, total, code, data) => {
                    this.newParttimePositionListTwo = res
                  }).catch(() => { })
                }
              }

            })
    },
    // 兼职三职位描述+不能重复+单店单岗
    parttimejobRepeatThree(el) {
      this.jobCode3 = 1
      let positionId = ''
        this.newParttimePositionListThree.forEach((item) => {
          if (item.positionCode === el) {
            positionId = item.positionId
          }
        })

        if(!el){return;}
      this.$request.get('/sys/commuser/needEffectiveEvaluation',
            {
              positionCode: el,
              userId: this.dataForm.userId
            }).then((res, tota,code, data) => {
              if (code !== 1) {
                let message = '当前AC测评服务不可用，请稍后再试。'
                this.$alert(message, this.$t('prompt.title')).then(() => { }).catch(() => { })
                this.modifyForm.partTimeJobcodeThree = ''
                this.isDisable = false
              } else if (code === 1 && res === 0) {
                let message = '该候选人暂无有效的关键管理职位评测记录，不可分配正式职位，请先分配非特殊职位。前往人才发展-评估中心-邀请候选人测评，可发起测评邀请。'
                this.$alert(message, this.$t('prompt.title')).then(() => { }).catch(() => { })
                this.modifyForm.partTimeJobcodeThree = ''
                this.isDisable = false
              }else{
                this.$request.get('/sys/commuser/singlePosition',
                  {
                    positionCode: el,
                    outletId: this.modifyForm.partTimeOutletThree,
                    userId: this.dataForm.userId
                  }
                ).then((res, total, code, data) => {
                  if (res.singlePosition === 1) {
                    // 提示当前岗位单店单岗，已被占用不可选择
                    // 提示当前岗位单店单岗，已被占用不可选择
                    let entry = this.outletThreeOrglist.find(item => {
                      if (item.orgId === this.modifyForm.partTimeOutletThree) {
                        return item
                      }
                    })
                    let message = '当前岗位已经被 “' + entry.name + '” 的 “' + res.userName + '(' + res.userCode + ')' + '” 占用，不可选择'
                    this.$alert(message, this.$t('prompt.title')).then(() => { }).catch(() => { })
                    this.modifyForm.partTimeJobcodeThree = ''
                  } else {
                    // 判断职位是否重复
                    if(this.checkRepeat()){
                       this.$alert(this.$t('user.verificationparttime'), this.$t('prompt.title')).then(() => {
                      }).catch(() => { })
                      this.modifyForm.partTimeJobcodeThree = ''
                    }
                    else{
                      this.jobCodeContentChangeThree(this.modifyForm.partTimeJobcodeThree)
                    }
                  }
                }).catch(() => { })
                if (this.modifyForm.partTimeJobcodeThree === '' || this.modifyForm.partTimeJobcodeThree === undefined || this.modifyForm.partTimeJobcodeThree === null) {
                  this.$request.post('/sys/commuser/commPositionTimeJob',
                    {
                      positionCode: this.modifyForm.jobCode,
                      positionName: '',
                      orgId: this.modifyForm.partTimeOutletThree
                    }
                  ).then((res, total, code, data) => {
                    this.newParttimePositionListThree = res
                  }).catch(() => { })
                }
              }

            })
    },
    // 兼职四职位描述+不能重复+单店单岗
    parttimejobRepeatFour(el) {
      this.jobCode4 = 1
      let positionId = ''
        this.newParttimePositionListFour.forEach((item) => {
          if (item.positionCode === el) {
            positionId = item.positionId
          }
        })
        if(!el){return;}
      this.$request.get('/sys/commuser/needEffectiveEvaluation',
            {
              positionCode: el,
              userId: this.dataForm.userId
            }).then((res, tota,code, data) => {
              if (code !== 1) {
                let message = '当前AC测评服务不可用，请稍后再试。'
                this.$alert(message, this.$t('prompt.title')).then(() => { }).catch(() => { })
                this.modifyForm.partTimeJobcodeFour = ''
                this.isDisable = false
              } else if (code === 1 && res === 0) {
                let message = '该候选人暂无有效的关键管理职位评测记录，不可分配正式职位，请先分配非特殊职位。前往人才发展-评估中心-邀请候选人测评，可发起测评邀请。'
                this.$alert(message, this.$t('prompt.title')).then(() => { }).catch(() => { })
                this.modifyForm.partTimeJobcodeFour = ''
                this.isDisable = false
              }else{
                this.$request.get('/sys/commuser/singlePosition',
                  {
                    positionCode: el,
                    outletId: this.modifyForm.partTimeOutletFour,
                    userId: this.dataForm.userId
                  }
                ).then((res, total, code, data) => {
                  if (res.singlePosition === 1) {
                    // 提示当前岗位单店单岗，已被占用不可选择
                    // 提示当前岗位单店单岗，已被占用不可选择
                    let entry = this.outletFourOrglist.find(item => {
                      if (item.orgId === this.modifyForm.partTimeOutletFour) {
                        return item
                      }
                    })
                    let message = '当前岗位已经被 “' + entry.name + '” 的 “' + res.userName + '(' + res.userCode + ')' + '” 占用，不可选择'
                    this.$alert(message, this.$t('prompt.title')).then(() => { }).catch(() => { })
                    this.modifyForm.partTimeJobcodeFour = ''
                  } else {
                    // 判断职位是否重复
                    if(this.checkRepeat()){
                       this.$alert(this.$t('user.verificationparttime'), this.$t('prompt.title')).then(() => {
                      }).catch(() => { })
                      this.modifyForm.partTimeJobcodeFour = ''
                    }
                    else{
                      this.jobCodeContentChangeFour(this.modifyForm.partTimeJobcodeFour)
                    }
                  }
                }).catch(() => { })
                if (this.modifyForm.partTimeJobcodeFour === '' || this.modifyForm.partTimeJobcodeFour === undefined || this.modifyForm.partTimeJobcodeFour === null) {
                  this.$request.post('/sys/commuser/commPositionTimeJob',
                    {
                      positionCode: this.modifyForm.jobCode,
                      positionName: '',
                      orgId: this.modifyForm.partTimeOutletFour
                    }
                  ).then((res, total, code, data) => {
                    this.newParttimePositionListFour = res
                  }).catch(() => { })
                }
              }

            })
    },
    // 兼职五职位描述+不能重复+单店单岗
    parttimejobRepeatFive(el) {
      this.jobCode5 = 1
      let positionId = ''
        this.newParttimePositionListFive.forEach((item) => {
          if (item.positionCode === el) {
            positionId = item.positionId
          }
        })
        if(!el){return;}
      this.$request.get('/sys/commuser/needEffectiveEvaluation',
            {
              positionCode: el,
              userId: this.dataForm.userId
            }).then((res, tota,code, data) => {
              if (code !== 1) {
                let message = '当前AC测评服务不可用，请稍后再试。'
                this.$alert(message, this.$t('prompt.title')).then(() => { }).catch(() => { })
                this.modifyForm.partTimeJobcodeFive = ''
                this.isDisable = false
              } else if (code === 1 && res === 0) {
                let message = '该候选人暂无有效的关键管理职位评测记录，不可分配正式职位，请先分配非特殊职位。前往人才发展-评估中心-邀请候选人测评，可发起测评邀请。'
                this.$alert(message, this.$t('prompt.title')).then(() => { }).catch(() => { })
                this.modifyForm.partTimeJobcodeFive = ''
                this.isDisable = false
              }else{
                this.$request.get('/sys/commuser/singlePosition',
                  {
                    positionCode: el,
                    outletId: this.modifyForm.partTimeOutletFive,
                    userId: this.dataForm.userId
                  }
                ).then((res, total, code, data) => {
                  if (res.singlePosition === 1) {
                    // 提示当前岗位单店单岗，已被占用不可选择
                    // 提示当前岗位单店单岗，已被占用不可选择
                    let entry = this.outletFiveOrglist.find(item => {
                      if (item.orgId === this.modifyForm.partTimeOutletFive) {
                        return item
                      }
                    })
                    let message = '当前岗位已经被 “' + entry.name + '” 的 “' + res.userName + '(' + res.userCode + ')' + '” 占用，不可选择'
                    this.$alert(message, this.$t('prompt.title')).then(() => { }).catch(() => { })
                    this.modifyForm.partTimeJobcodeFive = ''
                  } else {
                    // 判断职位是否重复
                    if(this.checkRepeat()){
                       this.$alert(this.$t('user.verificationparttime'), this.$t('prompt.title')).then(() => {
                      }).catch(() => { })
                      this.modifyForm.partTimeJobcodeFive = ''
                    }
                    else{
                      this.jobCodeContentChangeFive(this.modifyForm.partTimeJobcodeFive)
                    }
                  }
                }).catch(() => { })
                if (this.modifyForm.partTimeJobcodeFive === '' || this.modifyForm.partTimeJobcodeFive === undefined || this.modifyForm.partTimeJobcodeFive === null) {
                  this.$request.post('/sys/commuser/commPositionTimeJob',
                    {
                      positionCode: this.modifyForm.jobCode,
                      positionName: '',
                      orgId: this.modifyForm.partTimeOutletFive
                    }
                  ).then((res, total, code, data) => {
                    this.newParttimePositionListFive = res
                  }).catch(() => { })
                }
              }

            })
    },
    // 判断职位是否重复
    checkRepeat(){
      let _this = this;

      //将已添加的网点加职位添加到集合中，用来判断是否重复
      let outletCodeArr = [];
      //添加主职
      outletCodeArr.push(_this.modifyForm.outletId+"-"+_this.modifyForm.jobCode)
      //添加兼职1
      if(_this.modifyForm['partTimeOutletOne']&&_this.modifyForm['partTimeJobcodeOne']){
        outletCodeArr.push(_this.modifyForm['partTimeOutletOne']+"-"+_this.modifyForm['partTimeJobcodeOne'])
      }
      //添加兼职2
      if(_this.modifyForm['partTimeOutletTwo']&&_this.modifyForm['partTimeJobcodeTwo']){
        outletCodeArr.push(_this.modifyForm['partTimeOutletTwo']+"-"+_this.modifyForm['partTimeJobcodeTwo'])
      }
      //添加兼职3
      if(_this.modifyForm['partTimeOutletThree']&&_this.modifyForm['partTimeJobcodeThree']){
        outletCodeArr.push(_this.modifyForm['partTimeOutletThree']+"-"+_this.modifyForm['partTimeJobcodeThree'])
      }
      //添加兼职4
      if(_this.modifyForm['partTimeOutletFour']&&_this.modifyForm['partTimeJobcodeFour']){
        outletCodeArr.push(_this.modifyForm['partTimeOutletFour']+"-"+_this.modifyForm['partTimeJobcodeFour'])
      }
      //添加兼职5
      if(_this.modifyForm['partTimeOutletFive']&&_this.modifyForm['partTimeJobcodeFive']){
        outletCodeArr.push(_this.modifyForm['partTimeOutletFive']+"-"+_this.modifyForm['partTimeJobcodeFive'])
      }

      //进行去重
      let uniqueArr = Array.from(new Set(outletCodeArr))

      return outletCodeArr.length != uniqueArr.length;
    },
    //判断新职位是否与旧职位完全一致（即使顺序不同也不行）
    checkOldRepeat(){
      let _this = this;
      let oldOutletCodeArr = [];
      let newOutletCodeArr = [];

      //将旧的所有职位添加到集合中
      //添加旧主职
      oldOutletCodeArr.push(_this.dataForm.orgId+"-"+_this.dataForm.jobCode)
      //添加旧兼职1
      if(_this.dataForm['partTimeOutletOne']&&_this.dataForm['partTimeJobcodeOne']){
        oldOutletCodeArr.push(_this.dataForm['partTimeOutletOne']+"-"+_this.dataForm['partTimeJobcodeOne'])
      }
      //添加旧兼职2
      if(_this.dataForm['partTimeOutletTwo']&&_this.dataForm['partTimeJobcodeTwo']){
        oldOutletCodeArr.push(_this.dataForm['partTimeOutletTwo']+"-"+_this.dataForm['partTimeJobcodeTwo'])
      }
      //添加旧兼职3
      if(_this.dataForm['partTimeOutletThree']&&_this.dataForm['partTimeJobcodeThree']){
        oldOutletCodeArr.push(_this.dataForm['partTimeOutletThree']+"-"+_this.dataForm['partTimeJobcodeThree'])
      }
      //添加旧兼职4
      if(_this.dataForm['partTimeOutletFour']&&_this.dataForm['partTimeJobcodeFour']){
        oldOutletCodeArr.push(_this.dataForm['partTimeOutletFour']+"-"+_this.dataForm['partTimeJobcodeFour'])
      }
      //添加旧兼职5
      if(_this.dataForm['partTimeOutletFive']&&_this.dataForm['partTimeJobcodeFive']){
        oldOutletCodeArr.push(_this.dataForm['partTimeOutletFive']+"-"+_this.dataForm['partTimeJobcodeFive'])
      }

      //将新的所有职位添加到集合中
      //添加新主职
      newOutletCodeArr.push(_this.modifyForm.orgId+"-"+_this.modifyForm.jobCode)
      //添加新兼职1
      if(_this.modifyForm['partTimeOutletOne']&&_this.modifyForm['partTimeJobcodeOne']){
        newOutletCodeArr.push(_this.modifyForm['partTimeOutletOne']+"-"+_this.modifyForm['partTimeJobcodeOne'])
      }
      //添加新兼职2
      if(_this.modifyForm['partTimeOutletTwo']&&_this.modifyForm['partTimeJobcodeTwo']){
        newOutletCodeArr.push(_this.modifyForm['partTimeOutletTwo']+"-"+_this.modifyForm['partTimeJobcodeTwo'])
      }
      //添加新兼职3
      if(_this.modifyForm['partTimeOutletThree']&&_this.modifyForm['partTimeJobcodeThree']){
        newOutletCodeArr.push(_this.modifyForm['partTimeOutletThree']+"-"+_this.modifyForm['partTimeJobcodeThree'])
      }
      //添加新兼职4
      if(_this.modifyForm['partTimeOutletFour']&&_this.modifyForm['partTimeJobcodeFour']){
        newOutletCodeArr.push(_this.modifyForm['partTimeOutletFour']+"-"+_this.modifyForm['partTimeJobcodeFour'])
      }
      //添加新兼职5
      if(_this.modifyForm['partTimeOutletFive']&&_this.modifyForm['partTimeJobcodeFive']){
        newOutletCodeArr.push(_this.modifyForm['partTimeOutletFive']+"-"+_this.modifyForm['partTimeJobcodeFive'])
      }

      //进行新旧重复判断，只有在新旧数据条数一致的时候才判断
      if(oldOutletCodeArr.length === newOutletCodeArr.length){
        return oldOutletCodeArr.every(old=>newOutletCodeArr.indexOf(old)>-1)
      }

      return false;
    },
    // 主要职位职位描述
    jobCodeContentChange(jobCode) {
      if (jobCode === '' || jobCode === undefined || jobCode === null) {
        this.jobCodeContentClean()
      } else {
        for (let i = 0; i < this.mainPositionList.length; i++) {
          if (jobCode === this.mainPositionList[i].positionCode) {
            this.jobCodeNum = this.$t('activiti.jobCodeNum') + this.mainPositionList[i].positionCode
            if (this.mainPositionList[i].positionDesc) {
              this.jobCodeContent = this.jobCodeNum + '<br/>' + this.$t('activiti.jobCodeContent') + this.mainPositionList[i].positionDesc.replace(/\n/g, "<br/>")
            } else {
              this.jobCodeContent = this.jobCodeNum + '<br/>' + this.$t('activiti.jobCodeContent')
            }
          }
        }
      }
    },
    // 兼职一职位描述
    jobCodeContentChangeOne(jobCode) {
      if (jobCode === '' || jobCode === undefined || jobCode === null) {
        this.jobCodeContentCleanOne()
      } else {
        for (let i = 0; i < this.newParttimePositionListOne.length; i++) {
          if (jobCode === this.newParttimePositionListOne[i].positionCode) {
            this.jobCodeOne = this.$t('activiti.jobCodeNum') + this.newParttimePositionListOne[i].positionCode
            if (this.newParttimePositionListOne[i].positionDesc) {
              this.jobCodeContentOne = this.jobCodeOne + '<br/>' + this.$t('activiti.jobCodeContent') + this.newParttimePositionListOne[i].positionDesc.replace(/\n/g, "<br/>")
            } else {
              this.jobCodeContentOne = this.jobCodeOne + '<br/>' + this.$t('activiti.jobCodeContent')
            }
          }
        }
      }
    },
    // 兼职二职位描述
    jobCodeContentChangeTwo(jobCode) {
      if (jobCode === '' || jobCode === undefined || jobCode === null) {
        this.jobCodeContentCleanTwo()
      } else {
        for (let i = 0; i < this.newParttimePositionListTwo.length; i++) {
          if (jobCode === this.newParttimePositionListTwo[i].positionCode) {
            this.jobCodeTwo = this.$t('activiti.jobCodeNum') + this.newParttimePositionListTwo[i].positionCode
            if (this.newParttimePositionListTwo[i].positionDesc) {
              this.jobCodeContentTwo = this.jobCodeTwo + '<br/>' + this.$t('activiti.jobCodeContent') + this.newParttimePositionListTwo[i].positionDesc.replace(/\n/g, "<br/>")
            } else {
              this.jobCodeContentTwo = this.jobCodeTwo + '<br/>' + this.$t('activiti.jobCodeContent')
            }
          }
        }
      }
    },
    // 兼职三职位描述
    jobCodeContentChangeThree(jobCode) {
      if (jobCode === '' || jobCode === undefined || jobCode === null) {
        this.jobCodeContentCleanThree()
      } else {
        for (let i = 0; i < this.newParttimePositionListThree.length; i++) {
          if (jobCode === this.newParttimePositionListThree[i].positionCode) {
            this.jobCodeThree = this.$t('activiti.jobCodeNum') + this.newParttimePositionListThree[i].positionCode
            if (this.newParttimePositionListThree[i].positionDesc) {
              this.jobCodeContentThree = this.jobCodeThree + '<br/>' + this.$t('activiti.jobCodeContent') + this.newParttimePositionListThree[i].positionDesc.replace(/\n/g, "<br/>")
            } else {
              this.jobCodeContentThree = this.jobCodeThree + '<br/>' + this.$t('activiti.jobCodeContent')
            }
          }
        }
      }
    },
    // 兼职四职位描述
    jobCodeContentChangeFour(jobCode) {
      if (jobCode === '' || jobCode === undefined || jobCode === null) {
        this.jobCodeContentCleanFour()
      } else {
        for (let i = 0; i < this.newParttimePositionListFour.length; i++) {
          if (jobCode === this.newParttimePositionListFour[i].positionCode) {
            this.jobCodeFour = this.$t('activiti.jobCodeNum') + this.newParttimePositionListFour[i].positionCode
            if (this.newParttimePositionListFour[i].positionDesc) {
              this.jobCodeContentFour = this.jobCodeFour + '<br/>' + this.$t('activiti.jobCodeContent') + this.newParttimePositionListFour[i].positionDesc.replace(/\n/g, "<br/>")
            } else {
              this.jobCodeContentFour = this.jobCodeFour + '<br/>' + this.$t('activiti.jobCodeContent')
            }
          }
        }
      }
    },
    // 兼职五职位描述
    jobCodeContentChangeFive(jobCode) {
      if (jobCode === '' || jobCode === undefined || jobCode === null) {
        this.jobCodeContentCleanFive()
      } else {
        for (let i = 0; i < this.newParttimePositionListFive.length; i++) {
          if (jobCode === this.newParttimePositionListFive[i].positionCode) {
            this.jobCodeFive = this.$t('activiti.jobCodeNum') + this.newParttimePositionListFive[i].positionCode
            if (this.newParttimePositionListFive[i].positionDesc) {
              this.jobCodeContentFive = this.jobCodeFive + '<br/>' + this.$t('activiti.jobCodeContent') + this.newParttimePositionListFive[i].positionDesc.replace(/\n/g, "<br/>")
            } else {
              this.jobCodeContentFive = this.jobCodeFive + '<br/>' + this.$t('activiti.jobCodeContent')
            }
          }
        }
      }
    },
    // 清空主要职位职位描述
    jobCodeContentClean() {
      this.jobCodeContent = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
      this.jobCodeNum = this.$t('activiti.jobCodeNum')
    },
    // 清空兼职职位1描述
    jobCodeContentCleanOne() {
      this.jobCodeContentOne = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
      this.jobCodeOne = this.$t('activiti.jobCodeNum')
    },
    // 清空兼职职位2描述
    jobCodeContentCleanTwo() {
      this.jobCodeContentTwo = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
      this.jobCodeTwo = this.$t('activiti.jobCodeNum')
    },
    // 清空兼职职位3描述
    jobCodeContentCleanThree() {
      this.jobCodeContentThree = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
      this.jobCodeThree = this.$t('activiti.jobCodeNum')
    },
    // 清空兼职职位4描述
    jobCodeContentCleanFour() {
      this.jobCodeContentFour = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
      this.jobCodeFour = this.$t('activiti.jobCodeNum')
    },
    // 清空兼职职位5描述
    jobCodeContentCleanFive() {
      this.jobCodeContentFive = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
      this.jobCodeFive = this.$t('activiti.jobCodeNum')
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      //防止连续点击
      this.isDisable = true
      this.$refs['modifyForm'].validate((valid) => {
        if (!valid) {
          this.isDisable = false
          return false
        } else if(this.checkOldRepeat()){
          this.$alert(this.$t('user.verificationparttimeJobCodeSame'), this.$t('prompt.title')).then(() => { }).catch(() => { })
          this.isDisable = false
        } else {
          if (this.dialogshow === true && this.dialogshow1 === true && this.dialogshow2 === true && this.dialogshow3 === true && this.dialogshow4 === true) {
            this.trandferForm = {
              // 用户id
              userId: this.modifyForm.userId,
              // 版本号
              version: this.dataForm.version,
              // 原主职网点id
              positionOriginalNetworkId: this.dataForm.orgId,
              // 目标主职网点id
              positionDestinationNetworkId: this.modifyForm.orgId,
              // 原主职code
              positionOriginalCode: this.dataForm.jobCode,
              // 目标主职code
              positionDestinationCode: this.modifyForm.jobCode,
              // 原兼职1网点id
              partTimeOneNetworkOriginalId: this.dataForm.partTimeOutletOne,
              // 目标兼职1网点id
              partTimeOneNetworkDestinationId: this.modifyForm.partTimeOutletOne,
              // 原兼职1code
              partTimeOneOriginalCode: this.dataForm.partTimeJobcodeOne,
              // 目标兼职1code
              partTimeOneDestinationCode: this.modifyForm.partTimeJobcodeOne,
              // 原兼职2网点id
              partTimeTwoNetworkOriginalId: this.dataForm.partTimeOutletTwo,
              // 目标兼职2网点id
              partTimeTwoNetworkDestinationId: this.modifyForm.partTimeOutletTwo,
              // 原兼职2code
              partTimeTwoOrignialCode: this.dataForm.partTimeJobcodeTwo,
              // 目标兼职2code
              partTimeTwoDestinationCode: this.modifyForm.partTimeJobcodeTwo,
              // 原兼职3网点id
              partTimeThreeNetworkOriginalId: this.dataForm.partTimeOutletThree,
              // 目标兼职3网点id
              partTimeThreeNetworkDestinationId: this.modifyForm.partTimeOutletThree,
              // 原兼职3code
              partTimeThreeOriginalCode: this.dataForm.partTimeJobcodeThree,
              // 目标兼职3code
              partTimeThreeDestinationCode: this.modifyForm.partTimeJobcodeThree,
              // 原兼职4网点id
              partTimeFourNetworkOriginalId: this.dataForm.partTimeOutletFour,
              // 目标兼职4网点id
              partTimeFourNetworkDestinationId: this.modifyForm.partTimeOutletFour,
              // 原兼职4code
              partTimeFourOriginalCode: this.dataForm.partTimeJobcodeFour,
              // 目标兼职4code
              partTimeFourDestinationCode: this.modifyForm.partTimeJobcodeFour,
              // 原兼职5网点id
              partTimeFiveNetworkOriginalId: this.dataForm.partTimeOutletFive,
              // 目标兼职5网点id
              partTimeFiveNetworkDestinationId: this.modifyForm.partTimeOutletFive,
              // 原兼职5code
              partTimeFiveOriginalCode: this.dataForm.partTimeJobcodeFive,
              // 目标兼职5code
              partTimeFiveDestinationCode: this.modifyForm.partTimeJobcodeFive
            }
            this.$request.post(`/sys/position/transfer/save`,
              this.trandferForm
            ).then((res, total, code, data) => {
              this.isDisable = false
              this.$message({
                message: this.$t('prompt.success'),
                type: 'success',
                duration: 500,
                onClose: () => {
                  this.visible = false
                  this.$emit('refreshDataList')
                }
              })
            }).catch(() => {this.isDisable = false })
          } else {
            this.visible = true
          }
        }
      })
    }, 2000, { 'leading': true, 'trailing': false })
  },
  activated() {
    this.modifyForm = {}
    this.dataForm = {}
  }
}
</script>
<style lang="scss" scoped>
.box {
  position: relative;
}
.line {
  height: 460px;
  width: 0px;
  border: 1px dashed #5e5ee4;
  box-sizing: border-box;
  position: absolute;
  left: 47.5%;
  top: -530px;
  z-index: 100;
}
</style>
<style lang="scss">
.user-transfer-islimit-modal {
  border-radius: 4px !important;
  display: flex;
  flex-direction: column;
  margin:0 !important;
  position:absolute;
  top:50%;
  left:50%;
  transform:translate(-50%,-50%);
  .el-dialog__header{
    padding: 15px 15px 10px;
  }
  .el-dialog__body {
    padding: 0 !important;
    color: #606266;
    font-size: 14px;
    overflow: hidden;
  }
}
</style>
